/**
 * «Убрать автоматические строки» — откат одного массового действия.
 *
 * Без неё единственным способом отменить неудачный автосбор была бы ручная
 * чистка семисот полей, и человек перестал бы нажимать кнопку после первого
 * же неудачного прогона. Подтверждение обязательно и говорит, чего НЕ
 * произойдёт: ручные строки и строки правил остаются на месте — их автосбор
 * своими не считает.
 */
import { useState } from 'react';
import { Button } from '@/components/ui/button';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';
import { useClearAutoRows } from '@/lib/planning/autoBuild';

export function ClearAutoRowsButton({
  scenarioId,
  autoRows,
  disabled,
}: {
  scenarioId: string;
  /** Сколько строк варианта собрано автоматически — счётчик на кнопке. */
  autoRows: number;
  disabled: boolean;
}) {
  const [open, setOpen] = useState(false);
  const clear = useClearAutoRows();
  if (autoRows === 0) return null;

  return (
    <>
      <Button
        type="button"
        size="sm"
        variant="outline"
        disabled={disabled || clear.isPending}
        onClick={() => setOpen(true)}
      >
        Убрать автоматические ({autoRows})
      </Button>

      <Dialog open={open} onOpenChange={(next) => !clear.isPending && setOpen(next)}>
        <DialogContent>
          <DialogHeader>
            <DialogTitle>Убрать строки, собранные автоматически?</DialogTitle>
            <DialogDescription>
              Это правка черновика — вариант не утверждается и на рабочий бюджет не
              влияет.
            </DialogDescription>
          </DialogHeader>
          <ul className="space-y-2 rounded-md border border-border bg-muted/40 p-3 text-sm">
            <li>
              У <span className="font-medium text-foreground">{autoRows}</span> полей
              культура будет убрана из плана — они снова станут свободными.
            </li>
            <li className="text-muted-foreground">
              Ручные строки и строки, назначенные правилами, не тронем.
            </li>
            <li className="text-muted-foreground">
              Факт прошлых сезонов автосбор не меняет вовсе.
            </li>
          </ul>
          <DialogFooter>
            <Button
              type="button"
              variant="outline"
              disabled={clear.isPending}
              onClick={() => setOpen(false)}
            >
              Отмена
            </Button>
            <Button
              type="button"
              disabled={clear.isPending}
              onClick={() =>
                clear.mutate(
                  { scenarioId },
                  { onSuccess: () => setOpen(false) },
                )
              }
            >
              {clear.isPending ? 'Убираем…' : 'Убрать автоматические'}
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
    </>
  );
}
